(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  // Load more products scripts
  const loadMoreButtons = document.querySelectorAll('.js-load-more');
  if (loadMoreButtons.length > 0) {
    loadMoreButtons.forEach(loadMoreButton => {
      
      loadMoreButton.addEventListener('click', function() {
      const nextPageUrl = loadMoreButton.getAttribute('data-next-url');
      const totalPages = parseInt(loadMoreButton.getAttribute('data-total-pages'));
      const currentPage = parseInt(loadMoreButton.getAttribute('data-current-page'));

      if (currentPage < totalPages) {
        loadMoreButton.disabled = true;
        loadMoreButton.querySelector('[data-load-more-text]').style.display = 'none';
        loadMoreButton.querySelector('[data-loading-text]').style.display = 'inline';

        fetch(nextPageUrl)
          .then(response => response.text())
          .then(data => {
            const parser = new DOMParser();
            const html = parser.parseFromString(data, 'text/html');
            const newItems = html.querySelectorAll('.blog-grid__item');

            const gridList = document.querySelector('.blog-grid__grid-list');
            newItems.forEach(item => {
              gridList.appendChild(item);
            });

            loadMoreButton.setAttribute('data-next-url', html.querySelector('.js-load-more').getAttribute('data-next-url'));
            loadMoreButton.setAttribute('data-current-page', html.querySelector('.js-load-more').getAttribute('data-current-page'));

            loadMoreButton.disabled = false;
            loadMoreButton.querySelector('[data-load-more-text]').style.display = 'inline';
            loadMoreButton.querySelector('[data-loading-text]').style.display = 'none';
          })
          .catch(error => {
            console.error('Error loading more products:', error);
            loadMoreButton.disabled = false;
            loadMoreButton.querySelector('[data-load-more-text]').style.display = 'inline';
            loadMoreButton.querySelector('[data-loading-text]').style.display = 'none';
          });
      } else {
        loadMoreButton.style.display = 'none';
      }
    });
  });
  }

  // Filter navigation scripts
  const navToggleButtons = document.querySelectorAll('.js-blog-grid-nav-toggle');
  if (navToggleButtons.length > 0) {
    navToggleButtons.forEach(navToggleButton => {

      // Event listener function to close the nav toggle when clicking outside of it
      const closeNavToggleFunction = function(event) {
        const navList = document.querySelector('.js-blog-grid-nav');
        const navToggle = document.querySelector('.js-blog-grid-nav-toggle');
        if (navList && navToggle && !navToggle.contains(event.target) && !navList.contains(event.target)) {
          navList.classList.remove('expanded');
          navToggle.setAttribute('aria-expanded', false);
        }
      };

      // Add event listener to toggle button for mobile
      navToggleButton.addEventListener('click', function() {
        const navList = navToggleButton.nextElementSibling;
        navList.classList.toggle('expanded');
        const isExpanded = navList.classList.contains('expanded');
        navToggleButton.setAttribute('aria-expanded', isExpanded);
        if (isExpanded) {
          document.addEventListener('click', closeNavToggleFunction, true);
        } else {
          document.removeEventListener('click', closeNavToggleFunction, true);
        }
      });

      // Add event listener to close button on menu for mobile
      const navToggleClose = document.querySelector('.js-blog-grid-nav-toggle-close');
      if (navToggleClose) {
        navToggleClose.addEventListener('click', function() {
          const navList = document.querySelector('.js-blog-grid-nav');
          navList.classList.remove('expanded');
          navToggleButton.setAttribute('aria-expanded', false);
        });
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  // Load more products scripts
  const loadMoreButtons = document.querySelectorAll('.js-load-more');
  if (loadMoreButtons.length > 0) {
    loadMoreButtons.forEach(loadMoreButton => {
      
      loadMoreButton.addEventListener('click', function() {
      const nextPageUrl = loadMoreButton.getAttribute('data-next-url');
      const totalPages = parseInt(loadMoreButton.getAttribute('data-total-pages'));
      const currentPage = parseInt(loadMoreButton.getAttribute('data-current-page'));

      if (currentPage < totalPages) {
        loadMoreButton.disabled = true;
        loadMoreButton.querySelector('[data-load-more-text]').style.display = 'none';
        loadMoreButton.querySelector('[data-loading-text]').style.display = 'inline';

        fetch(nextPageUrl)
          .then(response => response.text())
          .then(data => {
            const parser = new DOMParser();
            const html = parser.parseFromString(data, 'text/html');
            const newItems = html.querySelectorAll('.collection-grid__item');

            const gridList = document.querySelector('.collection-grid__grid-list');
            newItems.forEach(item => {
              gridList.appendChild(item);
            });

            
            const newCurrentPage = html.querySelector('.js-load-more').getAttribute('data-current-page');
            loadMoreButton.setAttribute('data-next-url', html.querySelector('.js-load-more').getAttribute('data-next-url'));
            loadMoreButton.setAttribute('data-current-page', newCurrentPage);

            if (parseInt(newCurrentPage) >= totalPages) {
              loadMoreButton.style.display = 'none';
            } else {
              loadMoreButton.disabled = false;
              loadMoreButton.querySelector('[data-load-more-text]').style.display = 'inline';
              loadMoreButton.querySelector('[data-loading-text]').style.display = 'none';
            }
          })
          .catch(error => {
            console.error('Error loading more products:', error);
            loadMoreButton.disabled = false;
            loadMoreButton.querySelector('[data-load-more-text]').style.display = 'inline';
            loadMoreButton.querySelector('[data-loading-text]').style.display = 'none';
          });
      } else {
        loadMoreButton.style.display = 'none';
      }
    });
  });
  }

  // Filter navigation scripts
  const navToggleButtons = document.querySelectorAll('.js-collection-grid-nav-toggle');
  if (navToggleButtons.length > 0) {
    navToggleButtons.forEach(navToggleButton => {

      // Event listener function to close the nav toggle when clicking outside of it
      const closeNavToggleFunction = function(event) {
        const navList = document.querySelector('.js-collection-grid-nav');
        const navToggle = document.querySelector('.js-collection-grid-nav-toggle');
        if (navList && navToggle && !navToggle.contains(event.target) && !navList.contains(event.target)) {
          navList.classList.remove('expanded');
          navToggle.setAttribute('aria-expanded', false);
        }
      };

      // Add event listener to toggle button for mobile
      navToggleButton.addEventListener('click', function() {
        const navList = navToggleButton.nextElementSibling;
        navList.classList.toggle('expanded');
        const isExpanded = navList.classList.contains('expanded');
        navToggleButton.setAttribute('aria-expanded', isExpanded);
        if (isExpanded) {
          document.addEventListener('click', closeNavToggleFunction, true);
        } else {
          document.removeEventListener('click', closeNavToggleFunction, true);
        }
      });

      // Add event listener to close button on menu for mobile
      const navToggleClose = document.querySelector('.js-collection-grid-nav-toggle-close');
      if (navToggleClose) {
        navToggleClose.addEventListener('click', function() {
          const navList = document.querySelector('.js-collection-grid-nav');
          navList.classList.remove('expanded');
          navToggleButton.setAttribute('aria-expanded', false);
        });
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  // Load more products scripts
  const loadMoreButtons = document.querySelectorAll('.js-load-more');
  if (loadMoreButtons.length > 0) {
    loadMoreButtons.forEach(loadMoreButton => {
      
      loadMoreButton.addEventListener('click', function() {
      const nextPageUrl = loadMoreButton.getAttribute('data-next-url');
      const totalPages = parseInt(loadMoreButton.getAttribute('data-total-pages'));
      const currentPage = parseInt(loadMoreButton.getAttribute('data-current-page'));

      if (currentPage < totalPages) {
        loadMoreButton.disabled = true;
        loadMoreButton.querySelector('[data-load-more-text]').style.display = 'none';
        loadMoreButton.querySelector('[data-loading-text]').style.display = 'inline';

        fetch(nextPageUrl)
          .then(response => response.text())
          .then(data => {
            const parser = new DOMParser();
            const html = parser.parseFromString(data, 'text/html');
            const newItems = html.querySelectorAll('.collection-grid__item');

            const gridList = document.querySelector('.collection-grid__grid-list');
            newItems.forEach(item => {
              gridList.appendChild(item);
            });

            
            const newCurrentPage = html.querySelector('.js-load-more').getAttribute('data-current-page');
            loadMoreButton.setAttribute('data-next-url', html.querySelector('.js-load-more').getAttribute('data-next-url'));
            loadMoreButton.setAttribute('data-current-page', newCurrentPage);

            if (parseInt(newCurrentPage) >= totalPages) {
              loadMoreButton.style.display = 'none';
            } else {
              loadMoreButton.disabled = false;
              loadMoreButton.querySelector('[data-load-more-text]').style.display = 'inline';
              loadMoreButton.querySelector('[data-loading-text]').style.display = 'none';
            }
          })
          .catch(error => {
            console.error('Error loading more products:', error);
            loadMoreButton.disabled = false;
            loadMoreButton.querySelector('[data-load-more-text]').style.display = 'inline';
            loadMoreButton.querySelector('[data-loading-text]').style.display = 'none';
          });
      } else {
        loadMoreButton.style.display = 'none';
      }
    });
  });
  }

  // Filter navigation scripts
  const navToggleButtons = document.querySelectorAll('.js-collection-grid-nav-toggle');
  if (navToggleButtons.length > 0) {
    navToggleButtons.forEach(navToggleButton => {

      // Event listener function to close the nav toggle when clicking outside of it
      const closeNavToggleFunction = function(event) {
        const navList = document.querySelector('.js-collection-grid-nav');
        const navToggle = document.querySelector('.js-collection-grid-nav-toggle');
        if (navList && navToggle && !navToggle.contains(event.target) && !navList.contains(event.target)) {
          navList.classList.remove('expanded');
          navToggle.setAttribute('aria-expanded', false);
        }
      };

      // Add event listener to toggle button for mobile
      navToggleButton.addEventListener('click', function() {
        const navList = navToggleButton.nextElementSibling;
        navList.classList.toggle('expanded');
        const isExpanded = navList.classList.contains('expanded');
        navToggleButton.setAttribute('aria-expanded', isExpanded);
        if (isExpanded) {
          document.addEventListener('click', closeNavToggleFunction, true);
        } else {
          document.removeEventListener('click', closeNavToggleFunction, true);
        }
      });

      // Add event listener to close button on menu for mobile
      const navToggleClose = document.querySelector('.js-collection-grid-nav-toggle-close');
      if (navToggleClose) {
        navToggleClose.addEventListener('click', function() {
          const navList = document.querySelector('.js-collection-grid-nav');
          navList.classList.remove('expanded');
          navToggleButton.setAttribute('aria-expanded', false);
        });
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-grid"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
  // Load more articles logic (adapted from blog-grid)
  const loadMoreButtons = document.querySelectorAll('.js-load-more');
  if (loadMoreButtons.length > 0) {
    loadMoreButtons.forEach(loadMoreButton => {
      loadMoreButton.addEventListener('click', function() {
        const nextPageUrl = loadMoreButton.getAttribute('data-next-url');
        const totalPages = parseInt(loadMoreButton.getAttribute('data-total-pages'));
        const currentPage = parseInt(loadMoreButton.getAttribute('data-current-page'));
        if (currentPage < totalPages) {
          loadMoreButton.disabled = true;
          loadMoreButton.querySelector('[data-load-more-text]').style.display = 'none';
          loadMoreButton.querySelector('[data-loading-text]').style.display = 'inline';
          fetch(nextPageUrl)
            .then(response => response.text())
            .then(data => {
              const parser = new DOMParser();
              const html = parser.parseFromString(data, 'text/html');
              const newItems = html.querySelectorAll('.recipe-grid__item');
              const gridList = document.querySelector('.recipe-grid__grid-list');
              newItems.forEach(item => {
                gridList.appendChild(item);
              });
              const newLoadMore = html.querySelector('.js-load-more');
              if (newLoadMore) {
                loadMoreButton.setAttribute('data-next-url', newLoadMore.getAttribute('data-next-url'));
                loadMoreButton.setAttribute('data-current-page', newLoadMore.getAttribute('data-current-page'));
                loadMoreButton.disabled = false;
                loadMoreButton.querySelector('[data-load-more-text]').style.display = 'inline';
                loadMoreButton.querySelector('[data-loading-text]').style.display = 'none';
              } else {
                loadMoreButton.style.display = 'none';
              }
            })
            .catch(error => {
              console.error('Error loading more articles:', error);
              loadMoreButton.disabled = false;
              loadMoreButton.querySelector('[data-load-more-text]').style.display = 'inline';
              loadMoreButton.querySelector('[data-loading-text]').style.display = 'none';
            });
        } else {
          loadMoreButton.style.display = 'none';
        }
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
// Filter navigation scripts
  const navToggleButtons = document.querySelectorAll('.js-recipe-hero-nav-toggle');
  if (navToggleButtons.length > 0) {
    navToggleButtons.forEach(navToggleButton => {

      // Event listener function to close the nav toggle when clicking outside of it
      const closeNavToggleFunction = function(event) {
        const navList = document.querySelector('.js-recipe-hero-nav');
        const navToggle = document.querySelector('.js-recipe-hero-nav-toggle');
        if (navList && navToggle && !navToggle.contains(event.target) && !navList.contains(event.target)) {
          navList.classList.remove('expanded');
          navToggle.setAttribute('aria-expanded', false);
        }
      };

      // Add event listener to toggle button for mobile
      navToggleButton.addEventListener('click', function() {
        const navList = navToggleButton.nextElementSibling;
        navList.classList.toggle('expanded');
        const isExpanded = navList.classList.contains('expanded');
        navToggleButton.setAttribute('aria-expanded', isExpanded);
        if (isExpanded) {
          document.addEventListener('click', closeNavToggleFunction, true);
        } else {
          document.removeEventListener('click', closeNavToggleFunction, true);
        }
      });

      // Add event listener to close button on menu for mobile
      const navToggleClose = document.querySelector('.js-recipe-hero-nav-toggle-close');
      if (navToggleClose) {
        navToggleClose.addEventListener('click', function() {
          const navList = document.querySelector('.js-recipe-hero-nav');
          navList.classList.remove('expanded');
          navToggleButton.setAttribute('aria-expanded', false);
        });
      }
    });
  }

// Use unique classes for collapsible logic in recipe hero
const COLLAPSIBLE_BREAKPOINT = 1088;
const recipeHero = document.querySelector('.recipe-hero');
if (recipeHero) {
  const collapsibleTriggers = recipeHero.querySelectorAll('.js-recipe-hero-collapsible-trigger');
  collapsibleTriggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      const parent = trigger.closest('.js-recipe-hero-collapsible');
      if (!parent) return;
      e.preventDefault();
      if (window.innerWidth >= COLLAPSIBLE_BREAKPOINT) {
        // Desktop: close all in this recipe hero only
        let wasActive = parent.classList.contains('is-active');
        recipeHero.querySelectorAll('.js-recipe-hero-collapsible').forEach(item => {
          if (item !== parent) {
            item.classList.remove('is-active');
            const btn = item.querySelector('.js-recipe-hero-collapsible-trigger');
            if (btn) btn.setAttribute('aria-expanded', 'false');
          }
        });
        if (!wasActive) {
          parent.classList.add('is-active');
          trigger.setAttribute('aria-expanded', 'true');
        } else {
          parent.classList.remove('is-active');
          trigger.setAttribute('aria-expanded', 'false');
        }
      } else {
        // Mobile/tablet: just toggle
        const isActive = parent.classList.toggle('is-active');
        trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      }
    });
  });
}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-hero-product-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sb-hero-slider')) {
 customElements.define('sb-hero-slider',class extends HTMLElement {
  connectedCallback(){
   if(this.cleanup)return;
   const slides=[...this.querySelectorAll('[data-hero-slide]')],prev=this.querySelector('[data-hero-prev]'),next=this.querySelector('[data-hero-next]'),status=this.querySelector('[data-hero-status]');
   if(slides.length<2)return;
   let index=0,timer,hover=false,focused=false,paused=this.dataset.autoplay!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches||Boolean(window.Shopify?.designMode);
   const schedule=()=>{clearTimeout(timer);if(!paused&&!hover&&!focused&&!document.hidden)timer=setTimeout(()=>{show(index+1);schedule();},Number(this.dataset.delay)||6000);};
   const show=(value,announce=false)=>{index=(value+slides.length)%slides.length;slides.forEach((slide,i)=>{slide.style.visibility=i===index?'visible':'hidden';slide.inert=i!==index;slide.setAttribute('aria-hidden',String(i!==index));});if(announce)status.textContent=`${index+1} / ${slides.length}`;};
   const back=()=>{show(index-1,true);schedule();},forward=()=>{show(index+1,true);schedule();};
   const enter=()=>{hover=true;schedule();},leave=()=>{hover=false;schedule();},focus=()=>{focused=true;schedule();},blur=e=>{if(!this.contains(e.relatedTarget)){focused=false;schedule();}};
   const select=e=>{const i=slides.findIndex(s=>s===e.target||s.contains(e.target));if(i>=0){paused=true;show(i,true);schedule();}};
   const listeners=[[prev,'click',back],[next,'click',forward],[this,'mouseenter',enter],[this,'mouseleave',leave],[this,'focusin',focus],[this,'focusout',blur],[document,'visibilitychange',schedule],[document,'shopify:block:select',select]];
   listeners.forEach(([el,event,fn])=>el.addEventListener(event,fn));show(0);schedule();
   this.cleanup=()=>{clearTimeout(timer);listeners.forEach(([el,event,fn])=>el.removeEventListener(event,fn));};
  }
  disconnectedCallback(){this.cleanup?.();this.cleanup=null;}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-holiday-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sb-holiday-finder')) {
  customElements.define('sb-holiday-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = [...this.querySelectorAll('[data-holiday-tab]')];
      this.panels = [...this.querySelectorAll('[data-holiday-panel]')];
      this.querySelector('.sb-holiday__tabs').hidden = false;
      this.classList.add('is-enhanced');
      this.activate(this.dataset.default || 'budget');
      this.clickHandler = event => {
        const tab = event.target.closest('[data-holiday-tab]');
        if (tab && this.contains(tab)) this.activate(tab.dataset.holidayTab);
      };
      this.addEventListener('click', this.clickHandler);
      this.blockHandler = event => {
        const panel = event.target.closest('[data-holiday-panel]');
        if (panel && this.contains(panel)) this.activate(panel.dataset.holidayPanel);
      };
      document.addEventListener('shopify:block:select', this.blockHandler);
    }
    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.blockHandler);
      this.removeEventListener('click', this.clickHandler);
      this.initialized = false;
    }
    activate(key) {
      const available = this.panels.filter(panel => panel.querySelector('a, .sb-holiday__editor-note'));
      if (!available.some(panel => panel.dataset.holidayPanel === key)) key = available[0]?.dataset.holidayPanel;
      this.tabs.forEach(tab => {
        tab.hidden = !available.some(panel => panel.dataset.holidayPanel === tab.dataset.holidayTab);
        tab.setAttribute('aria-pressed', String(tab.dataset.holidayTab === key));
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.holidayPanel !== key; });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-holiday-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sb-holiday-slider')) {
  customElements.define('sb-holiday-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const track = this.querySelector('[data-slide-track]');
      if (!track) return;
      const controls = this.querySelector('.sb-holiday__slider-controls');
      const previous = this.querySelector('[data-slide-prev]');
      const next = this.querySelector('[data-slide-next]');
      const status = this.querySelector('[data-slide-status]');
      let frame;
      const items = () => [...track.children];
      const update = () => {
        const cards = items();
        const rect = track.getBoundingClientRect();
        const visible = cards.map((card, index) => ({index, rect: card.getBoundingClientRect()})).filter(card => card.rect.right > rect.left + 2 && card.rect.left < rect.right - 2);
        const overflow = track.scrollWidth > track.clientWidth + 2;
        controls.hidden = !overflow;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        if (visible.length) status.textContent = status.dataset.label.replace('[first]', visible[0].index + 1).replace('[last]', visible.at(-1).index + 1).replace('[total]', cards.length);
      };
      const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); };
      const move = direction => {
        const cards = items();
        const distance = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
        track.scrollBy({left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      const prevClick = () => move(-1);
      const nextClick = () => move(1);
      const keydown = event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      };
      const selected = event => {
        if (!track.contains(event.target)) return;
        const card = event.target.closest('.featured-collection__item');
        if (card) track.scrollTo({left: card.offsetLeft - items()[0].offsetLeft, behavior: 'auto'});
      };
      previous.addEventListener('click', prevClick);
      next.addEventListener('click', nextClick);
      track.addEventListener('scroll', schedule, {passive: true});
      track.addEventListener('keydown', keydown);
      document.addEventListener('shopify:block:select', selected);
      const observer = new ResizeObserver(schedule);
      observer.observe(track);
      update();
      this.cleanup = () => {
        cancelAnimationFrame(frame); observer.disconnect();
        previous.removeEventListener('click', prevClick); next.removeEventListener('click', nextClick);
        track.removeEventListener('scroll', schedule); track.removeEventListener('keydown', keydown);
        document.removeEventListener('shopify:block:select', selected);
      };
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-holiday-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sb-review-slider')) {
  customElements.define('sb-review-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const slides = [...this.querySelectorAll('[data-review]')];
      const controls = this.querySelector('.sb-holiday__review-controls');
      const status = this.querySelector('[data-review-status]');
      const previous = this.querySelector('[data-review-prev]');
      const next = this.querySelector('[data-review-next]');
      let index = 0;
      const show = value => {
        if (!slides.length) return;
        index = (value + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.style.visibility = i === index ? 'visible' : 'hidden'; slide.setAttribute('aria-hidden', String(i !== index)); slide.inert = i !== index; });
        status.textContent = status.dataset.label.replace('[first]', index + 1).replace('[last]', index + 1).replace('[total]', slides.length);
      };
      const back = () => show(index - 1);
      const forward = () => show(index + 1);
      const select = event => { const selected = slides.findIndex(slide => slide === event.target || slide.contains(event.target)); if (selected >= 0) show(selected); };
      previous.addEventListener('click', back);
      next.addEventListener('click', forward);
      document.addEventListener('shopify:block:select', select);
      controls.hidden = slides.length < 2;
      show(0);
      this.cleanup = () => {
        previous.removeEventListener('click', back);
        next.removeEventListener('click', forward);
        document.removeEventListener('shopify:block:select', select);
      };
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Load more results script
  const loadMoreButtons = document.querySelectorAll('.js-load-more');
  if (loadMoreButtons.length > 0) {
    loadMoreButtons.forEach(loadMoreButton => {
      
      loadMoreButton.addEventListener('click', function() {
      const nextPageUrl = loadMoreButton.getAttribute('data-next-url');
      const totalPages = parseInt(loadMoreButton.getAttribute('data-total-pages'));
      const currentPage = parseInt(loadMoreButton.getAttribute('data-current-page'));

      if (currentPage < totalPages) {
        loadMoreButton.disabled = true;
        loadMoreButton.querySelector('[data-load-more-text]').style.display = 'none';
        loadMoreButton.querySelector('[data-loading-text]').style.display = 'inline';

        fetch(nextPageUrl)
          .then(response => response.text())
          .then(data => {
            const parser = new DOMParser();
            const html = parser.parseFromString(data, 'text/html');
            const newItems = html.querySelectorAll('.search-grid__item');

            const gridList = document.querySelector('.search-grid__list');
            newItems.forEach(item => {
              gridList.appendChild(item);
            });

            
            const newCurrentPage = html.querySelector('.js-load-more').getAttribute('data-current-page');
            loadMoreButton.setAttribute('data-next-url', html.querySelector('.js-load-more').getAttribute('data-next-url'));
            loadMoreButton.setAttribute('data-current-page', newCurrentPage);

            if (parseInt(newCurrentPage) >= totalPages) {
              loadMoreButton.style.display = 'none';
            } else {
              loadMoreButton.disabled = false;
              loadMoreButton.querySelector('[data-load-more-text]').style.display = 'inline';
              loadMoreButton.querySelector('[data-loading-text]').style.display = 'none';
            }
          })
          .catch(error => {
            console.error('Error loading more products:', error);
            loadMoreButton.disabled = false;
            loadMoreButton.querySelector('[data-load-more-text]').style.display = 'inline';
            loadMoreButton.querySelector('[data-loading-text]').style.display = 'none';
          });
      } else {
        loadMoreButton.style.display = 'none';
      }
    });
  });
  }
});

  } catch(e) { console.error(e); }
})();
})();
